import React, { FC, ChangeEvent, useState } from 'react'
import { Button } from 'transfix-ui/components/Button'
import { TextField } from 'transfix-ui/components/TextField'
import Box from 'transfix-ui/core/Box'
import { isValidNumericValue } from 'apps/marketplace/components/rfp/utils/strategyManager'

interface IMinimumMarginInputProps {
  lengthOfHaul: string
  minRate: string
  onSave: (minimumRate: string, lengthOfHaul: string) => void
  onCancel: () => void
}

export const MinimumMarginInput: FC<IMinimumMarginInputProps> = ({
  lengthOfHaul,
  minRate,
  onCancel,
  onSave,
}) => {
  const [minimumRate, setMinimumRate] = useState<string>(minRate)
  const [haulLength, setHaulLength] = useState<string>(lengthOfHaul)

  const onMinimumRateChange = (e: ChangeEvent<HTMLInputElement>) => {
    setMinimumRate(e.target.value)
  }

  const onLengthOfHaulChange = (e: ChangeEvent<HTMLInputElement>) => {
    setHaulLength(e.target.value)
  }

  const saveHandler = () => {
    onSave(minimumRate, haulLength)
  }

  const minimumRateIsValid = isValidNumericValue(minimumRate)
  const lengthOfHaulIsValid = isValidNumericValue(haulLength)
  const isValid = minimumRateIsValid && lengthOfHaulIsValid

  return (
    <>
      <Box mb={1} display='flex' alignItems='end'>
        <Box mr={1} flexGrow={1}>
          <TextField
            label='Minimum Margin $'
            placeholder='Minimum Margin $'
            value={minimumRate}
            onChange={onMinimumRateChange}
            error={!minimumRateIsValid}
            required
            large
          />
        </Box>
        <Box mb={1}>=</Box>
        <Box ml={1} flexGrow={1}>
          <TextField
            label='Length of Haul'
            placeholder='Length of Haul'
            value={haulLength}
            onChange={onLengthOfHaulChange}
            error={!lengthOfHaulIsValid}
            required
            large
          />
        </Box>
      </Box>
      <Box display='flex' justifyContent='flex-end'>
        <Box>
          <Button color='tertiary' onClick={onCancel}>
            Cancel
          </Button>
        </Box>
        <Box ml={1}>
          <Button color='primary' onClick={saveHandler} disabled={!isValid}>
            Save
          </Button>
        </Box>
      </Box>
    </>
  )
}
